import { Section, Missing, inr, qtyFmt } from "./costingUi";

function Line({ label, value, bold, testId, note }) {
  return (
    <div className={`flex items-center justify-between border-b border-stone-100 py-2 ${bold ? "font-semibold" : ""}`}>
      <span className="text-sm text-stone-700">{label}{note && <span className="ml-2 text-[11px] font-normal text-stone-400">{note}</span>}</span>
      <span data-testid={testId} className="font-mono text-sm text-stone-900">{value}</span>
    </div>
  );
}

export function CostBridge({ data }) {
  const { costBridge: b, perUnit: u, yield: y, totals: t } = data;
  const varTone = !t.complete ? "text-stone-500" : u.variance > 0 ? "text-rose-700" : u.variance < 0 ? "text-emerald-700" : "text-stone-900";
  return (
    <Section title="Cost Summary & Reconciliation" testId="recipe-cost-breakdown">
      <div className="grid gap-6 md:grid-cols-2">
        <div>
          <Line label="Ingredient cost" value={inr(b.ingredientCost)} testId="bridge-ingredient" note={!t.complete ? "incomplete" : null} />
          <Line label="+ Packaging cost" value={inr(b.packagingCost)} testId="bridge-packaging" note={b.packagingSource === "NONE_RECORDED" ? "none recorded" : null} />
          <Line label="+ Labour / overhead / other" value={inr(b.otherTotal)} testId="bridge-other" />
          <Line label="= Total calculated batch cost" value={inr(b.batchCost)} bold testId="bridge-batch-total" />
          <Line label="Finished yield" value={y.confirmed ? `${qtyFmt(y.qty)} ${y.unit}` : <Missing text="Yield not confirmed" testId="bridge-yield-missing" />} testId="bridge-yield" />
        </div>
        <div>
          <Line label="Cost / kg finished product" value={inr(u.costPerKgFinished) ?? <Missing text="Not available" />} testId="bridge-cost-per-kg" />
          <Line label="Cost / piece" value={inr(u.costPerPiece, 4) ?? <Missing text="Not available" />} testId="bridge-cost-per-piece" />
          <Line label="Current Cost / unit" value={inr(u.currentUnitCost, 4) ?? <Missing text={y.confirmed ? "No priced lines" : "Yield not confirmed"} />} bold testId="recipe-cost-per-unit" note={!t.complete ? "incomplete — understated" : null} />
          <Line label="Decided Cost / unit (locked)" value={inr(u.decidedCost, 4) ?? "Not set"} bold testId="bridge-decided" />
          <div className="flex items-center justify-between py-2">
            <span className="text-sm text-stone-700">Variance (Current − Decided)</span>
            <span data-testid="bridge-variance" className={`font-mono text-sm font-semibold ${varTone}`}>
              {u.variance != null ? `${inr(u.variance, 4)} (${u.variancePct ?? 0}%)${!t.complete ? " · indicative only" : ""}` : "—"}
            </span>
          </div>
        </div>
      </div>
      <p className="mt-3 text-[11px] text-stone-500">
        Current Cost is recalculated live from Ingredient Master prices. Decided Cost changes only through the approval control above. Production batch cost snapshots are never altered.
      </p>
    </Section>
  );
}
